// Perguntas da home. Também viram o schema FAQPage em src/routes/index.tsx.
export const homeFaqItems = [
  {
    question: "Como funciona a primeira consulta?",
    answer:
      "É uma conversa de cerca de 30 minutos, sem custo, por videochamada ou no consultório em Hamilton. Eu entendo seus objetivos e sua rotina e explico como funciona o acompanhamento. Depois você decide, com calma, se quer seguir.",
  },
  {
    question: "Você atende presencialmente ou só online?",
    answer:
      "Das duas formas. Presencialmente no consultório em Hamilton, Brisbane, e online por videochamada para quem mora em qualquer cidade da Austrália. A qualidade do acompanhamento é a mesma.",
  },
  {
    question: "Preciso falar inglês para o atendimento?",
    answer:
      "Não. Todo o atendimento é em português: consultas, plano alimentar, receitas e mensagens. Você explica o que sente na sua língua, sem precisar traduzir.",
  },
  {
    question: "Os planos usam os produtos que eu encontro aqui na Austrália?",
    answer:
      "Sim. Tudo é montado com o que você acha no Coles, Woolworths e Aldi, respeitando seu orçamento e sua rotina. Sem ingredientes que só existem no Brasil.",
  },
  {
    question: "Qual a diferença entre nutricionista e dietitian na Austrália?",
    answer:
      'Na Austrália, "dietitian" é um título ligado a um credenciamento específico (Accredited Practising Dietitian), e "nutritionist" não é um título regulado. Eu sou nutricionista com formação em Nutrição e atendo em português, com foco em plano alimentar e acompanhamento do dia a dia. Se você precisa de um tratamento clínico específico ou de encaminhamento do seu GP, me conte na primeira consulta e eu indico o melhor caminho.',
  },
  {
    question: "Tem reembolso do Medicare ou do plano de saúde?",
    answer:
      "Medicare não: o reembolso do Medicare é exclusivo de dietitians credenciadas (APD), e eu sou nutricionista. Plano de saúde privado depende do seu fundo e do pacote de extras; eu forneço o recibo e você confere a cobertura com o plano. Meus valores já são pensados para funcionar sem reembolso.",
  },
  {
    question: "Quanto custa o acompanhamento?",
    answer:
      "O valor depende do plano e da frequência das consultas. Na consulta inicial eu apresento as opções e os valores, e você decide com calma, depois de entender tudo.",
  },
  {
    question: "Não moro em Brisbane. Posso ser atendida?",
    answer:
      "Sim. Atendo online pacientes em Sydney, Melbourne, Perth, Adelaide, Gold Coast e qualquer outra cidade da Austrália, nos horários que cabem na sua rotina.",
  },
];
